module.exports = __webpack_public_path__ + "93b4b38fc801e529656abf87bf5f8e6d.png";